import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import classes from "./CommingSoon.module.css";

const container = document.querySelector("#root");

const CommingSoon = () => {
  return createPortal(
    <>
      <div className={classes.modal}>
        <div className={classes.title}>Coming Soon !</div>
        <div className={classes.description}>
          <div>We're crafting something special. Be among the first to explore it soon!</div>
        </div>
      </div>
    </>,
    container
  );
};

export default CommingSoon;
